<template>
  <div class="admin-layout" :class="{ 'sidebar-collapsed': isCollapsed }">
    <!-- 左侧侧边栏 -->
    <aside class="admin-sidebar">
      <div class="sidebar-logo">
        <template v-if="!isCollapsed">
          <img v-if="siteSettings.logo" :src="baseUrl + siteSettings.logo" :title="siteSettings.siteName" class="sidebar-logo__full" loading="lazy" />
          <img v-else src="@/assets/qianfanLogo.png" title="千帆学堂" class="sidebar-logo__full" />
          <span class="sidebar-logo__title">{{ siteSettings.siteName }}</span>
        </template>
        <span v-else class="sidebar-logo__mini">千帆</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapsed"
        :unique-opened="true"
        background-color="#111827"
        text-color="#9CA3AF"
        active-text-color="#FFFFFF"
        router
        class="sidebar-menu"
      >
        <el-menu-item index="/admin/dashboard">
          <i class="el-icon-s-home"></i>
          <span slot="title">仪表盘</span>
        </el-menu-item>
        <el-menu-item index="/admin/home-manage">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/about-manage">
          <i class="el-icon-document"></i>
          <span slot="title">公司介绍管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/product-manage">
          <i class="el-icon-goods"></i>
          <span slot="title">产品服务管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/honor-manage">
          <i class="el-icon-trophy"></i>
          <span slot="title">荣誉展示管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/news-manage">
          <i class="el-icon-reading"></i>
          <span slot="title">新闻动态管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/qna-manage">
          <i class="el-icon-chat-dot-round"></i>
          <span slot="title">一问一答管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/contact-manage">
          <i class="el-icon-phone"></i>
          <span slot="title">联系我们管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/teacher-manage">
          <i class="el-icon-s-custom"></i>
          <span slot="title">师资团队管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/user-manage">
          <i class="el-icon-user"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/settings">
          <i class="el-icon-setting"></i>
          <span slot="title">系统设置</span>
        </el-menu-item>
        <el-menu-item index="/admin/manual">
          <i class="el-icon-notebook-2"></i>
          <span slot="title">用户操作手册</span>
        </el-menu-item>
      </el-menu>
    </aside>

    <!-- 右侧内容区域 -->
    <div class="admin-main">
      <!-- 顶部导航栏 -->
      <header class="admin-topbar">
        <div class="topbar-left">
          <el-button
            type="text"
            class="collapse-btn"
            @click="toggleSidebar"
          >
            <i :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          </el-button>
          <span class="page-title">{{ $route.meta.title || '管理后台' }}</span>
        </div>
        <div class="topbar-right">
          <el-dropdown @command="handleCommand" trigger="click">
            <span class="admin-user">
              <el-avatar :size="32" icon="el-icon-user-solid"></el-avatar>
              <span class="admin-user__name">管理员</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">
                <i class="el-icon-user"></i> 系统信息
              </el-dropdown-item>
              <el-dropdown-item command="logout" divided>
                <i class="el-icon-switch-button"></i> 退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>

      <!-- 主体内容 -->
      <main class="admin-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { getSiteSettings } from "@/api/settings"
import config from '@/config'
import {logout} from "@/api/user";

export default {
  name: 'AdminLayout',
  data() {
    return {
      isCollapsed: false,
      baseUrl: config.baseApi,
      siteSettings: {
        siteName: '',
        logo: '',
      }
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    }
  },
  created() {
    this.fetchSettings()
  },
  methods: {
    async fetchSettings() {
      try {
        const res = await getSiteSettings()
        if (res && res.data && res.data.jsonContent && res.data.jsonContent.siteName) {
          this.siteSettings = res.data.jsonContent
        }
      } catch (e) {
        console.error('获取系统设置失败', e)
      }
    },
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 调用退出登录
          logout()
          setTimeout(()=>{
            // 清除登录状态
            localStorage.removeItem('admin_token')
            this.$message.success('已退出登录')
            this.$router.push('/admin/login')
          },1000)
        }).catch(() => {})
      } else if (command === 'profile') {
        if (this.$route.path !== '/admin/settings') {
          this.$router.push('/admin/settings')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/global.less';

@sidebar-width: 220px;
@sidebar-collapsed-width: 64px;
@topbar-height: 56px;

.admin-layout {
  display: flex;
  min-height: 100vh;
  background: @seed-section;
}

// 侧边栏
.admin-sidebar {
  width: @sidebar-width;
  min-height: 100vh;
  background: @seed-fg;
  transition: width 0.3s ease;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  overflow-x: hidden;
  overflow-y: auto;

  .sidebar-collapsed & {
    width: @sidebar-collapsed-width;
  }

  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }
}

.sidebar-logo {
  height: @seed-nav-h;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 0 16px;

  &__full {
    height: 60px;
    width: auto;
    object-fit: contain;
    display: block;
    flex-shrink: 0;
  }

  &__title {
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 600;
    font-family: @seed-font-display;
    white-space: nowrap;
    letter-spacing: 0.05em;
  }

  &__mini {
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 600;
  }
}

.sidebar-menu {
  border-right: none;

  .el-menu-item {
    height: 48px;
    line-height: 48px;
    margin: 4px 8px;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(255, 255, 255, 0.08) !important;
      color: #FFFFFF !important;
    }

    &.is-active {
      background-color: @seed-primary !important;
      color: #FFFFFF !important;
    }

    i {
      color: inherit;
      margin-right: 10px;
      font-size: 18px;
    }
  }

  // 折叠状态样式
  &.el-menu--collapse {
    width: @sidebar-collapsed-width;

    .el-menu-item {
      margin: 4px 4px;
      padding: 0 !important;
      text-align: center;

      i {
        margin-right: 0;
      }
    }
  }
}

// 右侧主区域
.admin-main {
  flex: 1;
  margin-left: @sidebar-width;
  transition: margin-left 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  .sidebar-collapsed & {
    margin-left: @sidebar-collapsed-width;
  }
}

// 顶部导航
.admin-topbar {
  height: @topbar-height;
  background: @seed-surface;
  border-bottom: 1px solid @seed-border;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: sticky;
  top: 0;
  z-index: 50;
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 12px;

  .collapse-btn {
    padding: 8px;
    color: @seed-muted;
    font-size: 20px;

    &:hover {
      color: @seed-primary;
    }
  }

  .page-title {
    font-size: 16px;
    font-weight: 500;
    color: @seed-fg;
    font-family: @seed-font-display;
  }
}

.topbar-right {
  display: flex;
  align-items: center;
}

.admin-user {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: @seed-radius;
  transition: background 0.2s;

  &:hover {
    background: @seed-primary-light;
  }

  &__name {
    font-size: 14px;
    color: @seed-fg;
    font-weight: 500;
  }

  .el-icon-arrow-down {
    font-size: 12px;
    color: @seed-muted;
  }
}

// 内容区域
.admin-content {
  flex: 1;
  padding: 24px;
  background: @seed-section;
  overflow-y: auto;
}
</style>
